import { render } from "./redaccionScreen.vue?vue&type=template&id=1d39aee7"
import script from "./redaccionScreen.vue?vue&type=script&lang=js"
export * from "./redaccionScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__